<mat-dialog-content>
  <h3>Add Course Lessons:</h3>
  <div [formGroup]="form">
    <ng-container formArrayName="possibleCommands">
      @for (lessonForm of possibleCommands.controls; track lessonForm; let i = $index) {
        <mat-card class="lesson-form-row" [formGroup]="lessonForm">
          <mat-form-field appearance="fill">
            <input matInput
              formControlName="keyName">
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-select formControlName="type">
              @for (type of dataType; track type) {
                <mat-option [value]="type">{{type}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button mat-icon-button color="warn" (click)="deletePossibleCommands(i)">
            <mat-icon>
              delete_forever
            </mat-icon>
          </button>
        </mat-card>
      }
    </ng-container>

  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="w100 flex-between-center">
    <button mat-flat-button color="accent" (click)="addPossibleCommands()">
      <mat-icon>add</mat-icon>
    </button>
    <div>
      <button class="fab" color="accent" mat-flat-button
        matTooltip="{{'button.save' | translate}}"
        [mat-dialog-close]="undefined">
        <mat-icon>clear</mat-icon>
      </button>
      <button class="fab" color="primary" mat-flat-button
        matTooltip="{{'button.save' | translate}}"
        (click)="sendValue()">
        <mat-icon>check</mat-icon>
      </button>
    </div>
  </div>

</mat-dialog-actions>

